export const INNER_MENU_SIZE = 576; // размер меню
export const CIRCLE_INNER_RADIUS = 87;
// центер внутреннего меню
export const CIRCLE_CENTER_X = INNER_MENU_SIZE / 2;
export const CIRCLE_CENTER_Y = INNER_MENU_SIZE / 2;

export const OUTER_MENU_SIZE = 840;
export const CHILD_CIRCLE_INNER_RADIUS = INNER_MENU_SIZE / 2;
// центр внешнего меню
export const CHILD_CIRCLE_CENTER_X = OUTER_MENU_SIZE / 2;
export const CHILD_CIRCLE_CENTER_Y = OUTER_MENU_SIZE / 2;

export const CIRCLE_GAP = 8;
